import React, { useEffect, useState } from "react";

import Form from "@Components/Form";
import { ROLES_URL, URLS } from "configs/constants";
import { fetchDataFromApi } from "utils";
const initialValues = {
  employee_id: "",
};

const PendingProfileUpdateViewDetails = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  const formFields = [
    { type: "title", title: "Profile Update" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Employee Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "role",
      key: "role",
      label: "Role",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company",
      key: "company",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone",
      key: "zone",
      label: "Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region",
      key: "region",
      label: "Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate",
      key: "estate",
      label: "Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "division",
      key: "division",
      label: "Division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "block",
      key: "block",
      label: "Block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Audit Details" },
    {
      type: "renderonly",
      name: "created_at",
      key: "created_at",
      label: "Created Date and Time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "created_by",
      key: "created_by",
      label: "Created By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "approved_rejected_by",
      key: "approved_rejected_by",
      label: "Approved/Rejected By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "remarks",
      key: "remarks",
      label: "Remarks",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
  ];
  const formButtons = ["cancel"];

  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl="user-profile-change/"
        listRoute={URLS.PENDING_APPROVAL_PROFILE}
        formFields={formFields}
        formButtons={formButtons}
        formTitle="Pending Profile Update"
        noTypography
      />
    </div>
  );
};

export default PendingProfileUpdateViewDetails;
